<template>
  <div id="app" :style="cssVars">
    <router-view :allConfig="allConfig" v-if="isRouterAlive" />
  </div>
</template>

<script>
import { getApolloConfig } from "network/login";
export default {
  name: "App",
  provide() {
    //provide/inject 组合：允许一个祖先组件向其所有子孙后代注入一个依赖，不论组件层次有多深，并在起上下游关系成立的时间里始终生效
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      allConfig: {},
      tableHeight: 0,
      isResize: false,
    };
  },
  computed: {
    cssVars() {
      return {
        "--tableHeight": this.tableHeight + 80 + "px",
        "--autoHeightTable": "auto",
      };
    },
  },
  created() {
    // 监听document的尺寸变化
    this.getConfigForWeb();
    // 页面刷新后vuex中的数据会重置,解决方法:
    // 刷新后: vuex再从sessionStorage中读取
    const store = sessionStorage.getItem("store");
    if (store) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(store))
      );
      sessionStorage.removeItem("store");
    }
    // 刷新前: 将数据存入sessionStorage中
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    // 监听网页
    try {
      this.miniScreen();
      window.addEventListener("resize", () => {
        // 节流
        if (!this.isResize) {
          this.isResize = true;
          setTimeout(() => {
            this.miniScreen();
            this.isResize = false;
          }, 1000);
        }
      });
    }catch (error) { }
  },

  methods: {
    // 缩小屏幕
    miniScreen() {
      if (document.documentElement.clientHeight < 768) {
        this.tableHeight = document.documentElement.clientHeight;
        document.documentElement.style.zoom = 0.68;
      } else {
        document.documentElement.style.zoom = 1;
      }
    },
    async getConfigForWeb() {
      console.log("getConfigForWeb");
      const result = await getApolloConfig();
      this.allConfig = result;
      sessionStorage.setItem("allConfig", JSON.stringify(result)); //存储allConfig
      this.$store.commit("saveAllConfigStorage", result);
      document.title = this.allConfig.projectName;
    },
    // 页面再次加载（用于页面新增、删除操作后的更新页面）
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style>
.custom-msgbox {
  width: 750px !important;
}
</style>
<style lang="scss">
@import url("assets/css/base.css");
@media screen and (max-height: 768px) {
  .el-dialog {
    width: auto;
    min-width: 300px;
    max-width: 100%;
    min-height: auto;
    max-height: 100%;
    //top: 50% !important;
    // transform: translateY(-120%) !important;
    margin: 0 auto !important;
    overflow: auto;
    /*高度自适应*/
  }
  .el-table {
    height: var(--tableHeight) !important;
  }
}
// 提示框遇英文超长时，自动换行
.el-message-box__message p {
  word-break: break-all;
}
.el-table__body-wrapper {
}

.el-button--primary {
  background-color: var(--ThemeColor, #409eff);
  border-color: var(--ThemeColor, #409eff);
  &.is-plain {
    color: var(--ThemeColor);
    border-color: rgba(var(--ThemeColorBGR), 0.5);
    background-color: rgba(var(--ThemeColorBGR), 0.1);
    &:hover,
    &:focus {
      background-color: var(--ThemeColor, #409eff);
      border-color: var(--ThemeColor, #409eff);
      color: #fff;
    }
  }
  &:hover,
  &:focus {
    background-color: var(--ThemeColor, #409eff);
    border-color: var(--ThemeColor, #409eff);
    opacity: 0.9;
  }
}
.tableOptionDiv {
  white-space: nowrap;
  display: inline-block;
  float: left;
}
</style>
